import React from "react";
import Seo from "@/components/Seo";
import HeroSection from "@/components/marketing/HeroSection";
import MediaLogos from "@/components/marketing/MediaLogos";
import TopSellers from "@/components/marketing/TopSellers";
import HowItWorksPreview from "@/components/marketing/HowItWorksPreview";
import Testimonials from "@/components/marketing/Testimonials";
import CTASection from "@/components/marketing/CTASection";
import DistributionExplainer from "@/components/marketing/DistributionExplainer";

export default function Home() {
  return (
    <>
      <Seo
        title="Press Release Distribution Platform"
        description="Digital24.com - Get your story everywhere that matters with our Press Release Distribution Platform."
      />
      <HeroSection />
      <MediaLogos />
      <DistributionExplainer />
      <TopSellers />
      <HowItWorksPreview />
      <Testimonials />
      <CTASection />
    </>
  );
}